import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/brandPublicity'
  },
  {
    path: '/brandPublicity',
    name: 'brandPublicity',
    component: () => import('../views/brandPublicity/brandPublicity.vue'),
    meta: {
      title: '感控工作间',
      keepAlive: true
    }
  },
  {
    path: '/luckyDraw',
    name: 'luckyDraw',
    component: () => import('../views/brandPublicity/luckyDraw.vue'),
    meta: {
      title: '抽奖',
      keepAlive: false
    }
  },
  {
    path: '/myPrize',
    name: 'myPrize',
    component: () => import('../views/brandPublicity/myPrize.vue'),
    meta: {
      title: '我的奖品',
      keepAlive: false
    }
  },
  {
    path: '/detail/monitorReport',
    name: 'monitorReport',
    component: () => import('../views/detail/monitorReport.vue'),
    meta: {
      title: '多机构医院感染日常监测',
      keepAlive: true
    }
  },
  {
    path: '/detail/inspection',
    name: 'inspection',
    component: () => import('../views/detail/inspection'),
    meta: {
      title: '多机构远程查验在线',
      keepAlive: true
    }
  },
  {
    path: '/list/moreScenes',
    name: 'moreScenes',
    component:() =>import('../views/list/moreScenes'),
    meta: {
      title: '更多使用场景',
      keepAlive: true
    }
  },
  {
    path: '/detail/scenesDetail',
    name: 'scenesDetail',
    component:() =>import('../views/detail/scenesDetail'),
    meta: {
      title: '使用场景详情',
      keepAlive: false
    }
  },
  {
    path: '/detail/myStory',
    name: 'myStory',
    component:() =>import('../views/detail/myStory'),
    meta: {
      title: '我们的故事',
      keepAlive: false
    }
  },
  {
    path: '/detail/myAIGkWeapon',
    name: 'myAIGkWeapon',
    component:() =>import('../views/detail/myAIGkWeapon'),
    meta: {
      title: 'AI驱动感控升级',
      keepAlive: false
    }
  },
  {
    path: '/file/file',
    name: 'file',
    component:() =>import('../views/file/file'),
    meta: {
      title: '文件',
      keepAlive: false
    }
  },
  {
    path: '/list/customerCase',
    name: 'customerCase',
    component:() =>import('../views/list/customerCase'),
    meta: {
      title: '客户案例',
      keepAlive: false
    }
  },
  {
    path: '/detail/caseDetail',
    name: 'caseDetail',
    component:() =>import('../views/detail/caseDetail'),
    meta: {
      title: '客户案例详情',
      keepAlive: false
    }
  },
  {
    path: '/detail/studyInline',
    name: 'studyInline',
    component: () => import('../views/detail/studyInline'),
    meta: {
      title: '多机构培训在线化',
      keepAlive: true
    }
  },
  {
    path: '/catalogue',
    name: 'catalogue',
    component: () => import('../views/brandPublicity/catalogue.vue'),
    meta: {
      title: '目录页',
      keepAlive: false
    }
  },
  {
    path: '/download/downloadApp',
    name: 'downloadApp',
    component: () => import('../views/download/downloadApp.vue'),
    meta: {
      title: '感控工作间APP下载',
      keepAlive: false
    }
  },
  {
    path: '/ourStory',
    name: 'ourStory',
    component: () => import('../views/brandPublicity/ourStory.vue'),
    meta: {
      title: '我们的故事',
      keepAlive: false
    }
  },
  {
    path: '/applyUse',
    name: 'applyUse',
    component: () => import('../views/brandPublicity/applyUse.vue'),
    meta: {
      title: '申请试用与购买',
      keepAlive: false
    }
  },
  {
    path: '/serviceList',
    name: 'serviceList',
    component: () => import('../views/serviceList/serviceList.vue'),
    meta: {
      title: '服务清单及价格',
      keepAlive: false
    }
  },
  {
  path: '/detail/scenesDetail',
  name: 'scenesDetail',
  component:() =>import('../views/detail/scenesDetail'),
  meta: {
  title: '使用场景详情',
  keepAlive: false
  }},
  {
    path: '/productIntroduce',
    name: 'productIntroduce',
    component: () => import('../views/brandPublicity/productIntroduce.vue'),
    meta: {
      title: '产品功能介绍',
      keepAlive: false
    }
  },
  {
    path: '/areaSceneDetails',
    name: 'areaSceneDetails',
    component: () => import('../views/brandPublicity/areaSceneDetails.vue'),
    meta: {
      title: '产品详情',
      keepAlive: false
    }
  },
  {
    path: '/ceshi',
    name: 'ceshi',
    component: () => import('../views/brandPublicity/ceshi.vue'),
    meta: {
      title: '测试',
      keepAlive: false
    }
  },
  {
    path: '/testQRCode',
    name: 'testQRCode',
    component: () => import('../views/test/testQRCode.vue'),
    meta: {
      title: '测试',
      keepAlive: false
    }
  },
]

const router = new VueRouter({
  base: process.env.NODE_ENV == "production" ? "/activity/" : "/" ,
  mode: 'hash',
  // mode: 'hash',
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior(to,from,savePosition) {
      console.log(to,'去哪里..');
      if (to.path != '/brandPublicity') {
         return {x: 0, y: 0};
      }
         
      }
})

export default router
